import React, { Component } from "react";
import axios from "axios";
import {
  Button,
  TextField,
  Typography,
  Box,
  Card,
  CardContent,
  CardActionArea,
  TablePagination,IconButton
} from "@mui/material";
import Serverurl from "./Apiurl";
import Fab from '@mui/material/Fab';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';

class Quoteothercharges extends Component {
  constructor(props) {
    super(props);
    this.state = {
      othercharges: [],
      page: 0,
      rowsPerPage: 5,
      totalItems: 0,
      searchName: "",
    };
  }

  componentDidMount() {
    this.fetchOthercharges();
  }

  fetchOthercharges = () => {
	    const bu_id = localStorage.getItem("GBuserid");
    axios
      .get(
        Serverurl +
          "ajaxothercharges.php?action=getall&StartIndex=" +
          this.state.page +
          "&PageSize=" +
          this.state.rowsPerPage +
          "&otc_title=" +
          this.state.searchName+
      "&otc_bu_id=" + bu_id 
      )
      .then((res) => {
        this.setState({
          othercharges: res.data || [],
          totalItems: parseInt(res.data?.[0]?.total || 0),
        });
      });
  };

  onPageChange = (event, newPage) => {
    this.setState({ page: newPage }, this.fetchOthercharges);
  };

  onRowsPerPageChange = (event) => {
    this.setState(
      { rowsPerPage: parseInt(event.target.value), page: 0 },
      this.fetchOthercharges
    );
  };

  render() {
    return (
      <Box sx={{ p: 2 }}>
        {/* Search */}
       

<Box sx={{ display: 'flex', flexDirection: 'column', mb: 3}}>

  <Box sx={{ display: 'flex' }}>
    <TextField
      variant="outlined"
      value={this.state.searchName}
      onChange={this.handleSearchChange}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          this.fetchOthercharges();
        }
      }}
      size="small"
      fullWidth
      placeholder="Type here..."
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={this.fetchOthercharges} edge="end">
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  </Box>
</Box>



       

        {/* List */}
        {this.state.othercharges.map((o) => (
          <Card key={o.otc_id} sx={{ mb: 2 }}>
            <CardActionArea onClick={() => this.props.onSelect(o)}>
              <CardContent>
                <Typography variant="h6">{o.otc_title}</Typography>
                <Typography variant="subtitle1">₹ {o.otc_price}</Typography>
                <Typography variant="body2">
                  GST: {o.otc_tax}%
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}

        {/* Pagination */}
		{this.state.totalItems > 0 && (
        <TablePagination
  component="div"
  count={this.state.totalItems}
  page={this.state.page}
  onPageChange={this.onPageChange}
  rowsPerPage={this.state.rowsPerPage}
  onRowsPerPageChange={this.onRowsPerPageChange}
  rowsPerPageOptions={[5, 10, 25, 50]}
/>
)}

{/* Floating Action Button */}
<Fab
  aria-label="add"
  onClick={this.props.onAddNew}
  sx={{
    position: 'fixed',
    bottom: 24,
    right: 24,
    zIndex: 1000,
    backgroundColor: '#11408f',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: '#0d3476',
    },
  }}
>
  Add
</Fab>

      </Box>
    );
  }
}

export default Quoteothercharges;
